import React from 'react';
import './App.css';

function App() {
  return (
    <main className="page">
      <div className="brand" aria-label="verrills.net">
        <svg className="brand-mark" viewBox="0 0 48 48" aria-hidden="true">
          <rect width="48" height="48" rx="10" fill="#1681c4" />
          <path d="M11 11h8l7 19 7-19h8L29 38h-7L11 11z" fill="#fff" />
          <circle cx="39" cy="38" r="2.5" fill="#37bd70" />
        </svg>
        <span className="brand-name">verrills<span className="brand-domain">.net</span></span>
      </div>
    </main>
  );
}

export default App;
